<mat-form-field>
  <mat-label>Supported File Types</mat-label>
  <mat-select [(ngModel)]="accept" multiple>
    @for (possibleFileEnding of possibleFileEndings; track possibleFileEnding) {
      <mat-option [value]="possibleFileEnding">{{ possibleFileEnding }}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-checkbox [(ngModel)]="multiple">{{ 'Allow Multiple Uploads' }}</mat-checkbox>
<mat-checkbox [(ngModel)]="showFileList">{{ 'Show File List' }}</mat-checkbox>
<mat-checkbox [(ngModel)]="removable">{{ 'Removable File' }}</mat-checkbox>

<mad-file-upload
  [accept]="accept"
  [multiple]="multiple"
  [text]="'Upload File'"
  [showFileList]="showFileList"
  [removable]="removable"
  [id]="'upload'"
  (fileEmitter)="filesEmitted($event)"
  (errorEmitter)="errorReceived($event)"
/>
